import PageLayout from 'components/PageLayout';
import MWPageTitle from 'pages/MWPageTitle';
import React, { useEffect, useState } from 'react';
import PatientSearchFromEHR from './PatientSearchFromEHR';
import { PatientSearchFromEHRDetails } from './Model';
import PatientDetails from './PatientDetails';
import PatientParentDetails from './PatientParentDetails';
import { Button, Grid, Typography } from '@mui/material';
import { getSchemeList } from 'reduxStore/getSchemeList/getSchemeListSlice';
import { useAppDispatch } from 'reduxStore/hooks';
import Footer from 'pages/Footer';
import DocumentVerifier from './DocumentVerifier';
import { useNavigate } from 'react-router-dom';

export default function DocumentVerification() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getSchemeList());
  }, []);
  const [searchPatientDetails, setSearchPatientDetails] = useState(
    {} as PatientSearchFromEHRDetails,
  );
  console.log('searchPatientDetails', searchPatientDetails);
  const updateSearchPatientDetails = (passedVal: PatientSearchFromEHRDetails) => {
    setSearchPatientDetails(passedVal);
  };
  return (
    <PageLayout>
      <Grid container direction='row' justifyContent='space-between' alignItems='stretch'>
        <Grid item xs={6} sm={6} sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}>
          <MWPageTitle title={'Document Verification'} backButton />
        </Grid>
        <Grid
          item
          xs={6}
          sm={6}
          sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
        >
          <Button
            variant='contained'
            color='primary'
            sx={{ float: 'right' }}
            onClick={() => navigate('/patient-document-verification-list')}
          >
            View Document List
          </Button>
        </Grid>
      </Grid>
      {/* {actualPageMarkup} */}
      <PatientSearchFromEHR updateSearchPatientDetails={updateSearchPatientDetails} />
      <PatientDetails patientDetails={searchPatientDetails} />
      <Typography variant='h5' color='primary' gutterBottom sx={{ fontWeight: 'bold' }}>
        Parent Details:
      </Typography>
      <PatientParentDetails />
      <Typography variant='h5' color='primary' gutterBottom sx={{ fontWeight: 'bold' }}>
        Verifier Action Area:
      </Typography>
      <DocumentVerifier />
      <Footer />
    </PageLayout>
  );
}
